import { render, staticRenderFns } from "./DealClient.vue?vue&type=template&id=f8ed19ac"
import script from "./DealClient.vue?vue&type=script&lang=js"
export * from "./DealClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports